import analytics from './actions/analytics';
import billing from './actions/billing';
import dashboard from './actions/dashboard';
import player from './actions/player';
import product from './actions/product';
import show from './actions/show';
import user from './actions/user';

export default {
    ...analytics,
    ...billing,
    ...dashboard,
    ...player,
    ...product,
    ...show,
    ...user,
};
